export interface ILine {
    id: string,
    color: string
}

export const COUNT_OF_DEGREES_TICKS = 5;
export const X_TIMESCALE_MAX_VALUE = 60;
export const Y_SCALE_MAX_VALUE = 20;
export const VELOCITY_Y_SCALE_MAX_VALUE = 120;